export const menu = {
  name: "Menu",
  sections: [
    {
      name: "Matricula",
      icon: "plus",
      options: [
        {
          url: "/dashboard",
          name: "Dashboard",
          permission: "",
        },
        {
          url: "/financers",
          name: "Aprovação - Financeira",
          permission: "onboarding.can_view_summary_data",
        },
        {
          url: "/health",
          name: "Aprovação - Ficha de Saúde",
          permission: "health.can_view_and_approve_healthdata",
        },
        {
          url: "/academic",
          name: "Aprovação - Acadêmica",
          permission: "documents.can_view_and_approve_documentdata",
        },
        {
          url: "/naap",
          name: "Aprovação - NAAP",
          permission: "onboarding.can_view_and_approve_naap",
        },
        {
          url: "/invite",
          name: "Convocação",
          permission: "invites.view_menu_convocacao",
        },
        {
          url: "/importacao",
          name: "Importação",
          permission: "core.view_imporacao_menu",
        },
        {
          url: "/contracts",
          name: "Assinatura de contratos",
          permission: "onboarding.can_view_and_approve_financedata",
        },
        {
          url: "/reports",
          name: "Relatórios",
          permission: "",
        },
      ],
    },
    {
      name: 'Relatórios',
      icon: 'file',
      options: [
        {
          url: '/reports',
          name: "Relatórios",
        },
        {
          url: '/reports/sql',
          name: "Relatórios SQL",
        },
      ]
    },
    {
      name: "Transferência Externa",
      icon: "arrow-left",
      options: [
        {
          url: '/transferencias/processos',
          name: "Processos",
          permission: "transfers.view_transferprocess",
        },
        {
          url: '/transferencias/aplicacoes/documental',
          name: "Aprovação - Secretaria",
          permission: "transfers.view_application_document_approval",
        },
        {
          url: '/transferencias/aplicacoes/academico',
          name: "Aprovação - Coordenação",
          permission: "transfers.view_application_academic_approval",
        }
      ]
    }
  ],
}

export default menu
